import type { IconSvgObject } from './types';

const Road01Icon: IconSvgObject = [
  ["path", { d: "M6 21.9999H18C19.1046 21.9999 20 21.1045 20 19.9999V3.99991C20 2.89534 19.1046 1.99991 18 1.99991H6C4.89543 1.99991 4 2.89534 4 3.99991V19.9999C4 21.1045 4.89543 21.9999 6 21.9999Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 11L12 13M12 5.5L12 7.5M12 16.5L12 18.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Road01Icon;
